// extracted by mini-css-extract-plugin
export default {"semesters":"_3Sb2s6K5","sem1":"_1HsFB7Bs","sem2":"AdBoDBmv","sem3":"_2qYxqufx","sem4":"n5iI6MK1"};